var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43208",
    "data-name": "Group 43208",
    transform: "translate(6032 -6144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15540",
    "data-name": "Rectangle 15540",
    transform: "translate(-6032 6144)",
    fill: "rgba(212,216,222,0)",
    stroke: "#d4d8de",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40931",
    "data-name": "Group 40931",
    transform: "translate(-6018 6158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15542",
    "data-name": "Rectangle 15542",
    width: 20,
    height: 20,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.266 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_42",
    d: "M63.875,68.107c-5.933.192-16.6-10.393-11.645-16.139l.839-.728a2.243,2.243,0,0,1,3.152.034c.021.021,1.372,1.776,1.372,1.776a2.259,2.259,0,0,1,0,3.122l-.758.9a1.009,1.009,0,0,0-.132,1.09,9.294,9.294,0,0,0,4.17,4.179.993.993,0,0,0,1.09-.132l.907-.762a2.263,2.263,0,0,1,3.122,0s1.755,1.35,1.776,1.372a2.262,2.262,0,0,1,0,3.19l-.664.762A4.509,4.509,0,0,1,63.875,68.107Z",
    transform: "translate(-50.954 -50.61)",
    fill: "#868d97"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCircle);
export default __webpack_public_path__ + "static/media/phone-circle.82e453a387ef32a102c760b93424888a.svg";
export { ForwardRef as ReactComponent };